import { render, staticRenderFns } from "./CrmDashboard.vue?vue&type=template&id=7cb9333a&scoped=true"
import script from "./CrmDashboard.vue?vue&type=script&lang=js"
export * from "./CrmDashboard.vue?vue&type=script&lang=js"
import style0 from "./CrmDashboard.vue?vue&type=style&index=0&id=7cb9333a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb9333a",
  null
  
)

export default component.exports